import React from 'react';
import styled from 'styled-components';
import { X } from 'lucide-react';
import { theme } from '../../design-system';
import { useTopAdContext } from '../../context/TopAdContext';

const Bar = styled.div`
  background: ${theme.colors.primary[600]};
  color: #fff;
  font-size: 0.85rem;
  padding: 8px 16px;
`;

const Inner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  position: relative;
  text-align: center;
`;

const Message = styled.a`
  color: #fff;
  text-decoration: none;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const SponsoredTag = styled.span`
  font-size: 0.7rem;
  font-weight: 400;
  opacity: 0.75;
  margin-left: 6px;
`;

const CloseButton = styled.button`
  position: absolute;
  right: 0;
  background: transparent;
  border: none;
  color: #fff;
  opacity: 0.8;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 2px;

  &:hover {
    opacity: 1;
  }
`;

const TopAnnouncementBar = () => {
  const { ad, hasVisibleTopBarAd, dismissTopBarAd } = useTopAdContext();

  if (!hasVisibleTopBarAd) return null;

  return (
    <Bar>
      <Inner>
        <Message href={ad.ad_URL} target="_blank" rel="noopener noreferrer sponsored">
          {ad.ad_title}
          <SponsoredTag>Sponsored</SponsoredTag>
        </Message>
        <CloseButton onClick={dismissTopBarAd} aria-label="Dismiss">
          <X size={16} />
        </CloseButton>
      </Inner>
    </Bar>
  );
};

export default TopAnnouncementBar;
